// extracted by mini-css-extract-plugin
export default {"service_detail":"ServiceDetail_service_detail__fSbff","service_detail_row":"ServiceDetail_service_detail_row__vrIXG"};